import { observer } from 'mobx-react-lite'
import { SecurityViewModel } from './SecurityViewModel'
import { useScopedViewModel } from '@/hooks/view-model-hooks'
import { useDocumentTitle } from '@/hooks/document-title'
import { ResetPasswordDialogContainer } from './ResetPasswordDialog/ResetPasswordDialogContainer'
import { ResetPasswordViewModel } from './ResetPasswordDialog/ResetPasswordViewModel'
import {
  SecurityView,
  MFAEnrollPanel,
  MFAEnrolledPanel,
  ResetPasswordSection,
} from './index'

export default observer(function SecurityViewContainer() {
  const vm = useScopedViewModel(
    ({ iam }) => new SecurityViewModel(iam.multiFactorAuthStore),
  )
  const resetPasswordVm = useScopedViewModel(
    ({ iam, shell }) =>
      new ResetPasswordViewModel(
        iam.userStore,
        iam.getCurrentWorkspace,
        iam.getCurrentUser,
        shell.createSnackbarErrorHandler,
      ),
  )

  useDocumentTitle('Security')

  return (
    <>
      <SecurityView>
        {vm.isUserEnrolled ? (
          <MFAEnrolledPanel />
        ) : (
          <MFAEnrollPanelContainer vm={vm} />
        )}

        <ResetPasswordSection onPasswordResetPress={resetPasswordVm.open} />
      </SecurityView>

      <ResetPasswordDialogContainer vm={resetPasswordVm} />
    </>
  )
})

interface MFAEnrollPanelContainerProps {
  vm: SecurityViewModel
}

export const MFAEnrollPanelContainer = observer(
  function MFAEnrollPanelContainer({ vm }: MFAEnrollPanelContainerProps) {
    const handleEnroll = async () => {
      if (vm.isUserEnrolled) {
        return
      }

      const url = await vm.fetchEnrollmentUrl()
      window.open(url)
    }

    return <MFAEnrollPanel onEnrollPress={handleEnroll} />
  },
)
